export const NOTIFICATIONS_API_URLS = {
  USER_NOTIFICATIONS: `/notification-center/inbox`,
};
